import { MessageProcessor } from '../websocketProcessorTypes'
import store from '../../redux/store'
import {
  setWaitingRoomStatus,
  setGameEndedStatus,
  setCharterTeamReady,
} from '../../redux/slices/waitingRoomWebsocketSlice'
import { GameRoomStatus } from '../../redux/types/room'
import { getRoomDetails } from '../../redux/asyncThunks/room'

export const waitingRoomProcessors: MessageProcessor[] = [
  {
    type: 'status',
    handler: (data) => {
      if (data.status !== undefined) {
        store.dispatch(setWaitingRoomStatus(data.status))

        if (data.status === GameRoomStatus.COMPLETED) {
          store.dispatch(setGameEndedStatus(true))
          // Get the room ID from data if possible, or fallback to undefined
          const roomId = data.room_id
          if (roomId) {
            store.dispatch(getRoomDetails(roomId))
          }
        } else {
          store.dispatch(setGameEndedStatus(false))
        }
      }
    },
  },
  {
    type: 'charter_status_update',
    handler: (data) => {
      if (data.team_id !== undefined) {
        store.dispatch(
          setCharterTeamReady({
            teamId: data.team_id,
            ready: data.status === 'locked',
            allTeamsReady: data.all_teams_ready,
          })
        )
      }
    },
  },
]
